<template>
    <article>
        <SectionLabel :label="trads.label"></SectionLabel>
        <Loader v-if="loading" :loading="true"></Loader>
        <section>
            <!--
                since we can't generate two items with v-for without wrapping them in a div
                instead we have two v-for, and reorder the items using CSS
            -->
            <label v-for="(reference, i) in references" :key="reference.id" :for="`reference-${reference.id}`" :style="{ order: i * 2 }">
                {{ $tradFor(reference.terms.name) }}
            </label>
            <input
                v-for="(reference, i) in references"
                :key="reference.id"
                type="text"
                :value="value[reference.id]"
                @input="e => change(reference.id, e.target.value)"
                :style="{ order: i * 2 + 1 }"
                :id="`reference-${reference.id}`"
            />
        </section>
    </article>
</template>

<script>
import TranslationInput from "./components/translation-input";
import SectionLabel from "./components/section-label";
import componentService from "@/services/component";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import Loader from "@/components/loader/loader";

export default {
    mixins: [TryLoadMixin],
    components: { TranslationInput, SectionLabel, Loader },
    data: () => ({ references: [] }),
    props: {
        value: { type: Object, required: true },
        componentType: { type: Number, required: true }
    },
    async created() {
        this.references = await this.tryLoad(() => componentService.properties(this.componentType));
    },
    computed: {
        trads() {
            return this.$trad.admin.componentForm.references;
        }
    },
    methods: {
        change(refId, value) {
            this.$emit("input", { ...this.value, [refId]: value });
        }
    }
};
</script>

<style lang="scss" scoped>
article {
    position: relative;
}
#main #component-form section {
    @media (min-width: 767px) {
        grid-template-columns: auto 1fr auto 1fr;
    }
}
</style>



// WEBPACK FOOTER //
// form-references.vue?ddabbef8